/**
 * Recharts can't read CSS variables, so chart strokes/fills are resolved to the
 * same values the design tokens declare in index.css. Kept in a `.ts` (not the
 * chart `.tsx`) so the literal colors live beside the token comment — mirrors
 * the proposals timeline's chartColors. Keep in lockstep with index.css.
 */
export const EXPANSION_CHART_COLORS = {
  brand: "#0994f2", // --cinch-brand
  gridLine: "hsl(0 0% 88%)",
  marker: "hsl(38 92% 50%)", // --status-warning — the contracted-allotment line
} as const;
